import { EboObject } from "../base-classes/ebo-object";

export class VinDetails extends EboObject {
  name: string;
  make: string;
  model: string;
  modelYear: number; //display on truck view
  ncsaMake: string; //display on truck view
  ncsaModel: string;
  series: string;
  trim: string; //display on truck view
  manufacturer: string;
  grossVehicleWeightRatingFrom: string;
  cabType: string; //display on truck view
  driveType: string; //display on truck view
  brakeSystemType: string; //display on truck view
  fuelType: string; //display on truck view
  note: string;

  // engine details
  numberOfCylinders: number;
  displacementLiters: number;
  engineModel: string;
  engineManufacturer: string; //display on truck view
  enginePowerKw: number;
  engineConfiguration: string;
  engineBrakeHpFrom: number;
  engineBrakeHpTo: number;

  //plant details
  plantCity: string;
  plantState: string;
  plantCountry: string;

  constructor(jsonData: Partial<VinDetails>) {
    super(jsonData);
  }
}